import React, { Component } from 'react'
import { getComplaintActions } from '../../Constant'

class ComplaintActionModel extends Component {
    state = {
        isLoading: false,
        actionTypes: [
            'Apology',
            'Free Hours',
            'Refund',
            'Money compensation',
            'Satisfied',
            'Other'
        ],
        action: '',
        note: '',
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    componentDidMount = () => { }

    render() {
        return (
            <div style={{ width: 800, paddingRight: 40 }}>
                <div className="header">
                    <b>Complaint Action Form</b>
                </div>
                <div className="body m-t-20">
                    <div className="row">
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Action</label>
                                <div className="col-sm-9">
                                    <select
                                        name="action"
                                        className="form-control"
                                        onChange={this.handleChange}
                                        value={this.state.action}
                                    >
                                        <option value="">Select Action</option>
                                        {getComplaintActions(this.props.type).map((data) => (
                                            <option
                                                value={data}
                                                key={data}
                                            >
                                                {data}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group row">
                                <label className="col-3 col-form-label">Note</label>
                                <div className="col-9">
                                    <textarea
                                        rows={7}
                                        className="form-control"
                                        onChange={this.handleChange}
                                        name="note"
                                        id="note"
                                        maxLength={700}
                                        placeholder=""
                                        value={this.state.note}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-right col-6 offset-6">
                            <button
                                onClick={() => this.props.postAction(this.state)}
                                className="btn hor-grd btn-grd-inverse offset-1"
                                disabled={this.state.action <= 0}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ComplaintActionModel
